import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable no-use-before-define */
import { deepExtract } from 'helpers/deep';
var SET_VENDOR_STATUS = 'classpass/vendor/SET_VENDOR_STATUS';
var STATUS = {
  AVAILABLE: 'available',
  LOADING: 'loading',
  PRELOADING: 'preloading'
};
var TRANSITIONS = [[STATUS.LOADING, STATUS.AVAILABLE], [STATUS.PRELOADING, STATUS.AVAILABLE], [STATUS.PRELOADING, STATUS.LOADING]];

function canTransition(state, status, vendor) {
  var vendorStatus = selectStatus(state, vendor);
  return !!TRANSITIONS.find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        from = _ref2[0],
        to = _ref2[1];

    return vendorStatus === from && status === to;
  });
}

function hasExpired(state, status, vendor) {
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var now = Date.now();
  return isStatus(state, status, vendor) && now - deepExtract("".concat(vendor, ".timestamp"), state, now) > duration;
}

function isStatus(state, status, vendor) {
  return selectStatus(state, vendor) === status;
}

function selectStatus(state, vendor) {
  return deepExtract("".concat(vendor, ".status"), state, STATUS.PRELOADING);
}

function setStatus(status, vendor) {
  return {
    type: SET_VENDOR_STATUS,
    vendor: vendor,
    status: status
  };
}

export function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var status = action.status,
      type = action.type,
      vendor = action.vendor;

  switch (type) {
    case SET_VENDOR_STATUS:
      return canTransition(state, status, vendor) ? _objectSpread({}, state, _defineProperty({}, vendor, {
        status: status,
        timestamp: Date.now()
      })) : state;

    default:
      return state;
  }
}

var withVendorState = function withVendorState(func, status) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return func.apply(void 0, [state.vendor, status].concat(args));
  };
};

export var hasLoadingExpired = withVendorState(hasExpired, STATUS.LOADING);
export var isAvailable = withVendorState(isStatus, STATUS.AVAILABLE);
export var isLoading = withVendorState(isStatus, STATUS.LOADING);
export var setAvailable = setStatus.bind(null, STATUS.AVAILABLE);
export var setLoading = setStatus.bind(null, STATUS.LOADING);